import { defaultAd300x250, IAdUnit } from "../unit";

export enum MobileContentPageScrollEnum {
  MobileContentPageScroll1="Mobile Content Page Scroll 1",
  MobileContentPageScroll2="Mobile Content Page Scroll 2",
  MobileContentPageScroll3="Mobile Content Page Scroll 3",
  MobileContentPageScroll4="Mobile Content Page Scroll 4",
  MobileContentPageScroll5="Mobile Content Page Scroll 5",
  MobileContentPageScroll6="Mobile Content Page Scroll 6",
  MobileContentPageScroll7="Mobile Content Page Scroll 7",
  MobileContentPageScroll8="Mobile Content Page Scroll 8",
  MobileContentPageScroll9="Mobile Content Page Scroll 9",
  MobileContentPageScroll10="Mobile Content Page Scroll 10",
}

export const MobileContentPageScrollUnits: {[name in MobileContentPageScrollEnum]: IAdUnit} = {
  [MobileContentPageScrollEnum.MobileContentPageScroll1]: {
    ...defaultAd300x250,
    sid: "978268",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll2]: {
    ...defaultAd300x250,
    sid: "978269",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll3]: {
    ...defaultAd300x250,
    sid: "978279",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll4]: {
    ...defaultAd300x250,
    sid: "978280",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll5]: {
    ...defaultAd300x250,
    sid: "978289",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll6]: {
    ...defaultAd300x250,
    sid: "978290",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll7]: {
    ...defaultAd300x250,
    sid: "978294",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll8]: {
    ...defaultAd300x250,
    sid: "978295",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll9]: {
    ...defaultAd300x250,
    sid: "978298",
  },
  [MobileContentPageScrollEnum.MobileContentPageScroll10]: {
    ...defaultAd300x250,
    sid: "1083112",
  },
};
